<!-- 确认框弹窗 -->
<template>
  <el-dialog class="confirm-modal" :visible="show" :before-close="cancel" :close-on-click-modal="false">
    <span slot="title">{{title}}</span>
    <div>{{content}}</div>
    <span slot="footer">
      <el-button type="primary" @click="confirm">确 定</el-button><el-button @click="cancel">取 消</el-button>
    </span>
  </el-dialog>
</template>
<script>
  export default {
    props: {
      show: {
        type: Boolean,
        default: false,
        required: true
      },
      title: {
        type: String,
        default: ' '
      },
      content: {
        type: String,
        required: true
      }
    },
    methods: {
      confirm () {
        this.$emit('confirm-click')
      },
      cancel () {
        this.$emit('cancel-click')
      }
    }
  }
</script>
<style lang="scss">
  .confirm-modal {
    font-family: "FZLanTingHei-DB-GBK", "Microsoft YaHei";

    .el-dialog {
      @include absolute-center;
      top: 50% !important;
      margin-bottom: 0;
      width: 467px;
      margin:0 auto;
    }

    .el-dialog__header {
      padding-top: 0;
    }

    .el-dialog__headerbtn {
      margin-top: 20px;
    }

    .el-dialog__body {
      padding: 87px 20px 60px;
      font-size: 18px;
      color: #666;
      text-align: center;
    }

    .el-dialog__footer {
      padding: 0 20px 20px;
      text-align: center;

      .el-button {
        border-radius: 2px;
        width: 120px;
        height: 40px;
        font-family: "FZLanTingHei-DB-GBK", "Microsoft YaHei";
      }

      .el-button--primary {
        border: 1px solid $orange;
        background: $orange;
      }

      .el-button--default {
        border: 1px solid $orange;
        color: $orange;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Confirm.vue?6ea72cfc